
/* eslint-disable */
import styles from './style.module.scss';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import { t } from '@web-solutions/module-localization';
import { useNav } from 'src/onboarding/hooks/nav';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import Analytics from '@web-solutions/module-analytics';

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={styles.page}>
      {currentIndex !== 0 && (
        <div className={styles.back} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={styles.wrapperInfo}>
        <Title className={styles.title}>{t('onboarding.completelySafe.title')}</Title>
        <Text semibold className={styles.description}>
          {t('onboarding.completelySafe.subTitle')}
        </Text>
        <div className={styles.image}></div>
      </div>
      <div className={styles.blur}></div>

      <Button
        onClick={() => {
          Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
            page: 'completely-safe',
          });
          onNext();
        }}
        title={t('onboarding.completelySafe.continue')}
      />
    </div>
  );
}

export default Page;
